export default {
  eyebrow: 'Portal de socios',
  title: 'Facturación',
  description: 'Tu método de pago para la factura mensual de la plataforma y cada factura con su desglose completo.',
  toasts: {
    checkout_error: 'No se pudo iniciar el pago — inténtalo de nuevo.',
    action_error: 'La acción falló — inténtalo de nuevo.',
    onboarding_error: 'No se pudo iniciar la verificación. Inténtalo de nuevo.',
    payment_method_in_use:
      'Las licencias de tus restaurantes se facturan a este método de pago, así que no se puede eliminar. Reemplázalo por uno nuevo.',
  },
  payout_bank_account: {
    title: 'Cuenta bancaria para pagos',
    description:
      'Los pagos de la participación en ingresos llegan en {{currency}}. Stripe convierte la transferencia cuando llega.',
    toasts: {
      saved: 'Cuenta bancaria guardada',
      save_failed: 'No pudimos guardar la cuenta bancaria. Revisa los datos.',
    },
  },
  payout_onboarding: {
    title: 'Configura tu cuenta de pagos',
    description:
      'Tu reparto de ingresos se paga mensualmente a una cuenta de pagos de Stripe. Completa la verificación una sola vez; los pagos quedan en espera hasta entonces.',
    missing: {
      title: 'Aún falta para poder iniciar los pagos:',
      bank_account: 'Añade la cuenta bancaria a la que debe pagarse tu reparto de ingresos.',
      business_details: 'Completa los datos de tu empresa, como dirección, NIF o número de registro.',
      people: 'Añade los datos del representante, propietarios o directores de tu empresa.',
      documents: 'Sube los documentos de verificación que Stripe ha solicitado.',
      terms: 'Acepta los términos de servicio de Stripe.',
      other: 'Proporciona los datos restantes que Stripe ha solicitado.',
    },
    start: 'Iniciar verificación',
    continue: 'Continuar verificación',
    ready: 'Cuenta de pagos verificada; tu reparto de ingresos se paga automáticamente tras cada ciclo de facturación.',
  },
  payment_method: {
    title: 'Método de pago',
    empty: 'Sin método de pago registrado — la factura mensual aún no puede cobrarse automáticamente.',
    add: 'Añadir método de pago',
    replace: 'Reemplazar',
    remove: 'Eliminar',
    remove_confirm: {
      title: '¿Eliminar este método de pago?',
      description:
        'La tarjeta/mandato se desvincula de Stripe de inmediato. Sin método de pago, las facturas — incluidas las ya emitidas — se cobran mediante la factura alojada de Stripe en lugar de automáticamente.',
      confirm: 'Eliminar',
    },
  },
  invoices: {
    title: 'Facturas',
  },
};
